import * as actionTypes from '../actions/actionTypes';
import {
    updateObject
} from '../../shared/utility';

const initialState = {
    wifiSecurity: {},
    wifiSecurityLoading: false,
    wifiSecurityFail: false,
    wifiSecuritySuccess: false,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        // case actionTypes.GET_WIFI_SECURITY_LOADING:
        //     return updateObject(state, {
        //         wifiSecurity: {},
        //         wifiSecurityLoading: true
        //     });
        case actionTypes.SET_WIFI_SECURITY_SUCCESS:
            return updateObject(state, {
                wifiSecurity: action.payload?.message || {},
                wifiSecuritySuccess: true,
                wifiSecurityLoading: false
            });
        case actionTypes.SET_WIFI_SECURITY_FAIL:
            return updateObject(state, {
                wifiSecurity: {},
                wifiSecurityFail: true,
                wifiSecuritySuccess: false,
                wifiSecurityLoading: false
            });

        case actionTypes.GET_ALL_WIFI_SECURITY_SUMMARY_LOADING:
            return updateObject(state, {
                wifiSecurity: {},
                wifiSecurityLoading: true,
                wifiSecurityFail: false,
                wifiSecuritySuccess: false,
            });

        default: return state;
    }
};
export default reducer;

